import React, { createContext, useState, useContext } from 'react'
import PropTypes from 'prop-types'

import { createApiClient as createOrderApiClient } from './orderApiClient'

const OrderApiContext = createContext({})

const OrderApiContextProvider = ({ client: initialClient, children }) => {
  const [client, setClient] = useState(initialClient)
  return (
    <OrderApiContext.Provider value={{ client, setClient }}>
      {children}
    </OrderApiContext.Provider>
  )
}

OrderApiContextProvider.propTypes = {
  client: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
}

const useOrderApiClient = () => {
  const { client } = useContext(OrderApiContext)

  if (!client) {
    throw new Error(`Missing Order API client, did you forget to wrap your components in OrderApiContextProvider?`)
  }

  return client
}

export {
  OrderApiContext,
  OrderApiContextProvider,
  useOrderApiClient,
  createOrderApiClient
}
